import { render } from "./PopUp.vue?vue&type=template&id=4478796f&ts=true"
import script from "./PopUp.ts?vue&type=script&lang=ts&external"
export * from "./PopUp.ts?vue&type=script&lang=ts&external"

import "./PopUp.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__